import { forwardRef, type Ref, type SVGProps } from "react";
const IconPauseFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<rect width={4} height={18} x={9} y={7} fill="currentColor" rx={1} /><rect width={4} height={18} x={19} y={7} fill="currentColor" rx={1} /></svg>;
const ForwardRef = forwardRef(IconPauseFilledSVG);
ForwardRef.displayName = "IconPauseFilled";
export { ForwardRef as IconPauseFilled };